module.exports = __webpack_public_path__ + "static/the-antidote-4a68f37d9da02389ea9f662c8642ce7e.jpg";